/** The message to show for an RTK Query error, whatever shape it came in. */
export function errorMessage(error: unknown, fallback = 'Something went wrong'): string {
  if (!error) return fallback;
  const e = error as { data?: { error?: { message?: string; details?: { message?: string; field?: string }[] | { problems?: string[] } } }; error?: string; status?: number | string };
  const details = e.data?.error?.details;
  if (Array.isArray(details) && details[0]?.message) return `${details[0].field ? `${details[0].field}: ` : ''}${details[0].message}`;
  return e.data?.error?.message ?? e.error ?? fallback;
}
